// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Privacy-SideBar-Container {
  display: flex;
  flex-direction: column;
  margin-top: 135px;
}
.privactSidebar01 {
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
  height: 56px;
  display: flex;
  align-items: center;
  padding: 10px 32px;
  cursor: pointer;
}
.PrivacyPolicy-Container {
  display: flex;
  max-width: 1440px;
  margin: 0 auto;
}
.PrivacyPolicy-SideContainer {
  width: 268px;
  height: auto;
  background: #fff;
  overflow: hidden;
  transition: all 0.1s linear;
}
.Privacy-Content-Container {
  flex-grow: 1;
  width: 70%;
}
.Privacy-ContentContainer {
  height: calc(100vh - 130px);
  overflow-y: auto;
  padding: 0px 250px 0px 50px;
}
.PrivacyPolicy-Footer {
  max-width: 1440px;
  margin: 0 auto;
}
.activeprivacy {
  border-radius: 9px;
  background: #f9fafa;
  cursor: pointer;
  margin: 0px 16px;
  padding: 0px 16px;
  color: #061522;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
}
.Privacy-policy-heading {
  margin-top: 45px;
  color: #405261;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 112.5% */
}
.Privacy-policy-heading-content {
  color: #061522;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 34px; /* 141.667% */
  margin-top: 34px;
  margin-bottom: 12px;
}
.Privacy-policy-content-text {
  color: #405261;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
}
.Privacy-Line{
    background: #E5E9EC;
    height: 1px;
    width: 100%;
    margin: 44px 0px;
}
.Privacy-bulletPoint{
    margin: 20px 0px;
    list-style-type: square;
}`, "",{"version":3,"sources":["webpack://./src/pages/PrivacyPolicy/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".Privacy-SideBar-Container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 135px;\n}\n.privactSidebar01 {\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n  height: 56px;\n  display: flex;\n  align-items: center;\n  padding: 10px 32px;\n  cursor: pointer;\n}\n.PrivacyPolicy-Container {\n  display: flex;\n  max-width: 1440px;\n  margin: 0 auto;\n}\n.PrivacyPolicy-SideContainer {\n  width: 268px;\n  height: auto;\n  background: #fff;\n  overflow: hidden;\n  transition: all 0.1s linear;\n}\n.Privacy-Content-Container {\n  flex-grow: 1;\n  width: 70%;\n}\n.Privacy-ContentContainer {\n  height: calc(100vh - 130px);\n  overflow-y: auto;\n  padding: 0px 250px 0px 50px;\n}\n.PrivacyPolicy-Footer {\n  max-width: 1440px;\n  margin: 0 auto;\n}\n.activeprivacy {\n  border-radius: 9px;\n  background: #f9fafa;\n  cursor: pointer;\n  margin: 0px 16px;\n  padding: 0px 16px;\n  color: #061522;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 18px; /* 128.571% */\n}\n.Privacy-policy-heading {\n  margin-top: 45px;\n  color: #405261;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 112.5% */\n}\n.Privacy-policy-heading-content {\n  color: #061522;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 34px; /* 141.667% */\n  margin-top: 34px;\n  margin-bottom: 12px;\n}\n.Privacy-policy-content-text {\n  color: #405261;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 171.429% */\n}\n.Privacy-Line{\n    background: #E5E9EC;\n    height: 1px;\n    width: 100%;\n    margin: 44px 0px;\n}\n.Privacy-bulletPoint{\n    margin: 20px 0px;\n    list-style-type: square;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
